import React from 'react';
import PropTypes from 'prop-types';
import './PageTitleBar.css';

export default function PageTitleBar({ title, icon, children }) {
  return (
    <div role="heading" aria-level="1" className="page-title-bar">
      <div className="title-container">
        <div className="icon">
          <img src={icon} alt="" />
        </div>
        <div className="title">{title}</div>
      </div>
      {children}
    </div>
  );
}

PageTitleBar.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.node
};
